{
    "allUsers": "All Users",
    "search": "Search",
    "name": "Name",
    "system": "System",
    "loan":"Loan",
    "credit": "Credit",
    "mortage": "Mortage",
    "created-by": "Created by",
    "admin": "Admin",
    "demoUser": "Demo_user",
    "superUser":"SuperUser",
    "lastUpdatedBy": "Last Updated By",
    "createdFrom": "Created From",
    "event": "event",
    "to": "To",
    "updatedFrom": "Updated From",
    "format": "Format",
    "alphanumeric": "Alphanumeric",
    "boolean": "Boolean",
    "number": "Number",
    "date": "Date",
    "experianProtected": "Experian Protected",
    "sync": "sync",
    "reset": "Reset",
    "refresh": "Refresh",
    "yes": "Yes",
    "no": "No"
}